module.exports = __webpack_public_path__ + "static/media/icono_animador.e6eb96dd.svg";